"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = exports.ReportTemplateFileTypeIterable = exports.PostgresQuery = exports.Outputs = exports.Inputs = exports.ColumnConfig = void 0;
const _imports_1 = require("../_imports");
const ColumnConfig = __importStar(require("./ColumnConfig"));
exports.ColumnConfig = ColumnConfig;
const Inputs = __importStar(require("./Inputs"));
exports.Inputs = Inputs;
const Outputs = __importStar(require("./Outputs"));
exports.Outputs = Outputs;
const PostgresQuery = __importStar(require("./PostgresQuery"));
exports.PostgresQuery = PostgresQuery;
// ========   MAIN   ========
exports.ReportTemplateFileTypeIterable = [
    'docx',
    'xlsx',
    'digital',
];
// Zod schemas for Reporting.Config (discriminated union)
const DocxConfigSchema = _imports_1.z.object({
    input: Inputs.ConfigSchema,
    type: _imports_1.z.literal('docx'),
    output: Outputs.Docx.ConfigSchema,
});
const XlsxConfigSchema = _imports_1.z.object({
    input: Inputs.ConfigSchema,
    type: _imports_1.z.literal('xlsx'),
    output: Outputs.Xlsx.ConfigSchema,
});
const DigitalConfigSchema = _imports_1.z.object({
    input: Inputs.ConfigSchema,
    type: _imports_1.z.literal('digital'),
});
exports.ConfigSchema = _imports_1.z.discriminatedUnion('type', [
    DocxConfigSchema,
    XlsxConfigSchema,
    DigitalConfigSchema,
]);
//# sourceMappingURL=index.js.map